var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyurl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-copyURL_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copyURL_1",
    "data-name": "copyURL \\u2013 1",
    clipPath: "url(#clip-copyURL_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229",
    transform: "translate(-7 19.715)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_540",
    "data-name": "Rectangle 540",
    width: 30,
    height: 30,
    transform: "translate(7 -19.715)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Copy_text",
    "data-name": "Copy text",
    transform: "translate(12 -15.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_1",
    "data-name": "Rounded Rectangle 1",
    d: "M14.3,18.33H2.38A2.383,2.383,0,0,1,0,15.95V2.381A2.383,2.383,0,0,1,2.38,0H14.319A1.982,1.982,0,0,1,16.3,1.98V16.33A2,2,0,0,1,14.3,18.33ZM2.56,2.436v13.4H13.8V2.436Z",
    transform: "translate(3.701 3.67)",
    fill: "#8bc500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_1_copy",
    "data-name": "Rounded Rectangle 1 copy",
    d: "M204.5,711.272H202c-.039-.187,0,.2,0,0V696.657c.039-2.325,1.285-3.616,3.747-3.654h11.24c.2,0-.192-.038,0,0v2.436H204.5Z",
    transform: "translate(-201.986 -692.986)",
    fill: "#8bc500"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyurl);
export default __webpack_public_path__ + "static/media/copyurl.799bd3c650adc9bc79b9a5e37efa752a.svg";
export { ForwardRef as ReactComponent };